import { render, staticRenderFns } from "./ProductsLiabilityTurnovers.vue?vue&type=template&id=c12aa170"
import script from "./ProductsLiabilityTurnovers.vue?vue&type=script&lang=js"
export * from "./ProductsLiabilityTurnovers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports